import { render, staticRenderFns } from "./QuestionManage.vue?vue&type=template&id=3c5b4324&scoped=true"
import script from "./QuestionManage.vue?vue&type=script&lang=js"
export * from "./QuestionManage.vue?vue&type=script&lang=js"
import style0 from "./QuestionManage.vue?vue&type=style&index=0&id=3c5b4324&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5b4324",
  null
  
)

export default component.exports